// extracted by mini-css-extract-plugin
module.exports = {"Drills":"Drills_Drills__1190g","DrillTypesRow":"Drills_DrillTypesRow__3UKz6"};